import './MainPage-FrameStart.css';

export default function MainPageFrameStart() {
    return (
        <div id='MainPage-FrameStart'>
            <div id="transparent-square">
                <h1>La mejor opción para sus pedidos personalizados</h1>
            </div>
        </div>
    );

   
}